/**
 * @module AuthApi
 *  Apis must need auth details to trigger url - AuthApi
 */
import Env from '../../environment.js';
import axios from 'axios';
import store from '@/store';
/* eslint-disable */

export default {
/**
 * Call to an GET Authenticate api for response.
 * @function
 * @param {string} url - Url to get results
 * @returns {object} A promise that will return either a success object or an error object.
 */
  getApi: function (url) {
    const accountToken = store.getters.getAccountToken;
    return axios({
      method: "GET",
      url,
      headers: {
        Authorization: `Bearer ${accountToken}`,
        "app-id": `${Env.app_id}`,
        "app-secret": `${Env.app_secret}`
      }
    });
  },
  postApi: function (url, data) {
    const accountToken = store.getters.getAccountToken;
    return axios({
      method: "POST",
      url,
      headers: {
        Authorization: `Bearer ${accountToken}`,
        "app-id": `${Env.app_id}`,
        "app-secret": `${Env.app_secret}`
      },
      data,
    });
  },

  putApi: function (url, data) {
    const accountToken = store.getters.getAccountToken;
    return axios({
      method: "PUT",
      url,
      headers: {
        Authorization: `Bearer ${accountToken}`,
        "app-id": `${Env.app_id}`,
        "app-secret": `${Env.app_secret}`
      },
      data,
    });
  },

  deleteApi: function (url) {
    const accountToken = store.getters.getAccountToken;
    return axios({
      method: "DELETE",
      url,
      headers: {
        Authorization: `Bearer ${accountToken}`,
        "app-id": `${Env.app_id}`,
        "app-secret": `${Env.app_secret}`
      },
    });
  },

  /**
   * 
   * Validae given token with results
   */
  validateTokenWithResults(token) {

    const url = `${Env.url}/api/auth/login/verify`;
    return axios({
      method: 'POST',
      url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  
}
